/*

  r e q u e s t s
  Requests

  :description:
  A file to handle making web requests.
  
*/

export const loadJSON = url => {
  return new Promise(resolve => {
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('error', function (err) {
      if (!err) {
        err = {}
      }
      resolve(false)
    })
    xhr.addEventListener('load', function () {
      try {
        const data = JSON.parse(this.response)
        resolve(data)
      } catch (err) {
        resolve(null)
      }
    })

    xhr.open('GET', url)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send()
  })
}

export const postJSON = (url, data) => {
  return new Promise(resolve => {
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('error', function (err) {
      if (!err) {
        err = {}
      }
      resolve(false)
    })
    xhr.addEventListener('load', function () {
      try {
        const data = JSON.parse(this.response)
        resolve(data)
      } catch (err) {
        resolve(null)
      }
    })

    xhr.open('POST', url)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xhr.send(JSON.stringify(data))
  })
}

export const loadJSONF = async url => {
  let data = null
  try {
    const r = await fetch(url)
    data = await r.json()
  } catch (err) {}
  return data
}

export const postJSONF = async (url, data) => {
  let res = null
  try {
    const r = await fetch(url, {
      method: POST,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    res = await r.json()
  } catch (err) {}
  return res
}
